import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["align", "open", "transitioning", "zIndex"],
  _excluded2 = ["Wrapper", "align", "duration", "zIndex"];
import styled from 'foundations-theming/utils';
import { ModalTransitionContextProvider } from '../Modal/ModalTransitionContext';
import { PlainWrapper, TwoWayTransition } from '../TwoWayTransition/TwoWayTransition';
import { PANEL_TRANSITION_TIMING } from '../../../constants/times';
import { JUPITER_LAYER } from '../../constants';
import { jsx as _jsx } from "react/jsx-runtime";
const defaultDuration = parseInt(PANEL_TRANSITION_TIMING, 10);
const PanelTransitionWrapper = styled(_ref => {
  let {
      open,
      transitioning
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(PlainWrapper, Object.assign({
    "data-component-name": "Panel",
    "data-open-complete": open && !transitioning
  }, rest));
}).withConfig({
  displayName: "PanelTransition__PanelTransitionWrapper",
  componentId: "jiwqyk-0"
})(["transition-property:", ";transition-duration:", "ms;transform:", ";position:fixed;top:0;bottom:0;z-index:", ";", ";"], ({
  transitionActive
}) => transitionActive ? 'transform' : 'none', ({
  duration
}) => duration, ({
  align,
  open
}) => {
  if (open) return 'translateX(0%)';
  return align === 'left' ? 'translateX(-100%)' : 'translateX(100%)';
}, ({
  zIndex
}) => zIndex, ({
  align
}) => align === 'right' ? 'right: 0;' : 'left: 0;');
export const PanelTransition = _ref2 => {
  let {
      Wrapper = PanelTransitionWrapper,
      align = 'right',
      duration = defaultDuration,
      zIndex = JUPITER_LAYER
    } = _ref2,
    rest = _objectWithoutPropertiesLoose(_ref2, _excluded2);
  return /*#__PURE__*/_jsx(TwoWayTransition, Object.assign({}, rest, {
    align: align,
    ContextProvider: ModalTransitionContextProvider,
    duration: duration,
    transitionOnMount: true,
    Wrapper: Wrapper,
    zIndex: zIndex
  }));
};
PanelTransition.displayName = 'PanelTransition';